// 側邊選單 - 深淺模式調整

import { useEffect, useState } from 'react';
import { useTheme } from 'next-themes';
import { useTranslation } from 'react-i18next';

const MenuTheme = () => {
    const { t } = useTranslation();
    const [mounted, setMounted] = useState(false);
    const { theme, setTheme } = useTheme();

    useEffect(() => {
        setMounted(true); // 避免 SSR 和 CSR 不一致
    }, []);

    if (!mounted) return null;

    return (
        <div
            className="rounded-[4px] relative bg-black1 [&>*]:center-center [&>*]:flex-grow [&>*]:py-[8px] [&>*]:flex-shrink-0
            [&>button]:relative [&>button]:z-[1] hidden ulg:between-center"
        >
            <button onClick={() => setTheme('light')}>
                <span
                    className={`block w-[30px] h-[22px] bg-[url(/images/icon/menu_light.svg)] dark:bg-[url(/images/icon/menu_dark_light.svg)]
                    ${theme === 'light' ? 'filter-fff' : ''}`}
                />
            </button>

            <button onClick={() => setTheme('dark')}>
                <span
                    className={`block w-[30px] h-[22px] bg-[url(/images/icon/menu_dark.svg)] dark:bg-[url(/images/icon/menu_dark_dark.svg)]
                    ${theme === 'dark' ? 'filter-fff' : ''}`}
                />
            </button>

            <button
                onClick={() => setTheme('system')}
                className={`text-btn1 ${theme === 'system' ? 'text-[#fff]' : 'text-black4'}`}
            >
                {t('AUTO')}
            </button>

            <span
                className={`absolute inline-block z-[0] bg-bou rounded-[4px] h-full w-[33%]
                ${theme === 'light' ? 'left-0' : theme === 'dark' ? 'left-[33%]' : 'left-[67%]'}`}
            />
        </div>
    );
};

export default MenuTheme;
